// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__ql3iT","header":"Messages_header__1aU_0"};